<template>
    <main-content with_go_back_bar>
        <div class="pb-4 px-4">
            <settlement-detail v-if="is_detail_ready"
                               :settlement_withdraw_type="settlement_withdraw_type"
                               :settlement_data="settlement_data"
                               :total_amount="total_amount"
                               :status="status"
            >
            </settlement-detail>
        </div>
        <form v-if="status === walletTransactionStatus.PENDING"
              @submit.prevent="paySettlement()"
              id="pay-form"
              class="shadow-sm p-4"
        >
            <div class="row">
                <div class="col-12 col-md-6 my-2">
                    <label for="phone" v-text="$t('label.phone')"></label>
                    <input class="form-control" id="phone" v-model="form_data.phone">
                </div>
                <div class="col-12 col-md-6 my-2">
                    <label for="national_code" v-text="$t('label.national_code')"></label>
                    <input class="form-control" id="national_code" v-model="form_data.national_code">
                </div>
                <div class="col-12 my-2">
                    <button class="btn btn-success mx-2"
                            type="submit"
                            v-text="$t('btn.pay')"
                    >
                    </button>
                    <button class="btn btn-danger mx-2"
                            type="button"
                            v-text="$t('btn.cancel_settlement')"
                            @click="cancel_settlement()"
                    >
                    </button>
                </div>
            </div>
        </form>
    </main-content>
</template>

<script>
    import MainContent from "@/components/main-content";
    import {walletService} from "@/common/api.service";
    import $ from 'jquery';
    import SettlementDetail from '../components/settlement-detail';
    import {walletTransactionStatus} from "@/constants/walletTransactionStatus";

    export default {
        components: {
            MainContent,
            SettlementDetail,
        },
        data() {
            return {
                walletTransactionStatus,
                settlement_data: {},
                settlement_withdraw_type: null,
                total_amount: 0,
                status: null,
                form_data: {},
                is_detail_ready: false,
            };
        },
        mounted() {
            walletService.getSettlementDetailDay(this.$route.params.hashid).then(res => {
                this.settlement_withdraw_type = res.data.data.settlement_withdraw_type;
                this.settlement_data = res.data.data.settlement_data;
                this.total_amount = res.data.data.total_amount;
                this.status = res.data.data.status;
                this.is_detail_ready = true;
            });
        },
        methods: {
            paySettlement() {
                let form = $('pay-form');

                let params = {
                    wallet_transaction_id: this.$route.params.hashid,
                    phone: this.form_data.phone,
                    national_code: this.form_data.national_code,
                };

                walletService.paySettlementByAdminDay(params).then(response => {
                    window.location = response.data.data.oauth_url;
                }).catch(({response}) => {
                    if (response.data) {
                        form.validate().showErrors(response.data.data);
                    }

                    this.showMsg(form, 'danger', response.data.message);
                });
            },
            cancel_settlement() {
                walletService.adminCancelSettlement(this.$route.params.hashid).then(() => {
                    this.$router.push('/day-wallets/admin');
                });
            },
        },
    }
</script>
